import Routes from "components/Routes";
import { BrowserRouter } from "react-router-dom";
import "@jobber/components/styles";

function App() {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
}

export default App;
